import { Navigate, Outlet, useLocation } from "react-router-dom";
import AdminSidebar from "./sidebar/AdminSidebar";
import AdminHeader from "./header/AdminHeader";
import {
  isAdminAuthenticated,
  canAccessAdminPath,
  getDefaultAdminRoute,
} from "../utils/auth";
import "./AdminLayout.css";

export default function AdminLayout() {
  const location = useLocation();

  if (!isAdminAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (!canAccessAdminPath(location.pathname)) {
    return <Navigate to={getDefaultAdminRoute()} replace />;
  }

  return (
    <div className="admin-shell">
      <AdminSidebar />
      <div className="admin-shell__main">
        <AdminHeader />
        <div className="admin-shell__content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
